module.exports = __webpack_public_path__ + "28d47ba9791a7e63669e87c201c76b7b.jpg";